import { atom, useAtom } from "jotai";

import {
  type SubscriptionTypeEnum,
  type ValueComparisonType,
  type ValueIntComparisonInput,
} from "@north-beam/nb-client-side";

export type ValueComparisonInput = {
  comparisonOperator?: ValueComparisonType;
  value?: string;
};

const orderIdAtom = atom<string | null>(null);
const orderNumberAtom = atom<string | null>(null);
const customerIdAtom = atom<string | null>(null);

const orderValueAtom = atom<ValueComparisonInput | null>(null);
const discountValueAtom = atom<ValueComparisonInput | null>(null);
const shippingValueAtom = atom<ValueComparisonInput | null>(null);
const taxValueAtom = atom<ValueComparisonInput | null>(null);
const refundValueAtom = atom<ValueComparisonInput | null>(null);

const numberOfOrderItemsAtom = atom<Partial<ValueIntComparisonInput> | null>(
  null,
);
const numberOfTouchpointsAtom = atom<Partial<ValueIntComparisonInput> | null>(
  null,
);

const orderTypesAtom = atom<string[] | null>(null);

const attributedAtom = atom<string[] | null>(null);
const orderTagsAtom = atom<string[] | null>(null);
const sourceNameAtom = atom<string[] | null>(null);
const customerTagsAtom = atom<string[] | null>(null);
const subscriptionsAtom = atom<SubscriptionTypeEnum[] | null>(null);
const productsPurchasedAtom = atom<string[] | null>(null);
const discountCodesAtom = atom<string[] | null>(null);

export const defaultOrderPageSorting = {
  sortingField: "date",
  sortingOrder: "desc",
};
const orderPageSortingAtom = atom<{
  sortingField: string;
  sortingOrder: string;
} | null>(defaultOrderPageSorting);

const orderSummaryGraphKPILoading = atom(false);
const orderSummaryGraphLoading = atom(false);
const orderTableLoading = atom(false);

export const useOrderSummaryGraphKPILoading = () =>
  useAtom(orderSummaryGraphKPILoading);
export const useOrderSummaryGraphLoading = () =>
  useAtom(orderSummaryGraphLoading);
export const useOrderTableLoading = () => useAtom(orderTableLoading);
export const useOrderIdAtom = () => useAtom(orderIdAtom);
export const useOrderNumberAtom = () => useAtom(orderNumberAtom);
export const useCustomerIdAtom = () => useAtom(customerIdAtom);

export const useOrderValueAtom = () => useAtom(orderValueAtom);
export const useDiscountValueAtom = () => useAtom(discountValueAtom);
export const useShippingValueAtom = () => useAtom(shippingValueAtom);
export const useTaxValueAtom = () => useAtom(taxValueAtom);
export const useRefundValueAtom = () => useAtom(refundValueAtom);

export const useNumberOfOrderItemsAtom = () => useAtom(numberOfOrderItemsAtom);

export const useNumberOfTouchpointsAtom = () =>
  useAtom(numberOfTouchpointsAtom);

export const useOrderTypesAtom = () => useAtom(orderTypesAtom);
export const useAttributedAtom = () => useAtom(attributedAtom);
export const useOrderTagsAtom = () => useAtom(orderTagsAtom);
export const useSourceNameAtom = () => useAtom(sourceNameAtom);
export const useCustomerTagsAtom = () => useAtom(customerTagsAtom);
export const useSubscriptionsAtom = () => useAtom(subscriptionsAtom);
export const useProductsPurchasedAtom = () => useAtom(productsPurchasedAtom);
export const useDiscountCodesAtom = () => useAtom(discountCodesAtom);
export const useOrderPageSortingAtom = () => useAtom(orderPageSortingAtom);
